module.exports = "/_next/static/resources/box-8d9dd309919d7d8e498441c1334a45c0.webp";